<template>
  <div id="dataContent" class="mainBox">
    <div class="header">
      <span class="headerName">项目名称：</span>
      <div class="headerInput"><el-input v-model.trim="select_word" placeholder="输入项目名称（并按Enter键）" clearable
                     suffix-icon="iconfont icon-search" @keyup.enter.native="searchProject(1,select_word)"></el-input></div>
      <div><el-button type="primary"  class="searchButton" @click="searchProject(1,select_word)">搜索</el-button></div>
      <div><el-button type="primary"  class="addButton" @click="showAdd.show=true">上传文件</el-button></div>
    </div>
    <div class="mainContent" id="mainTabel">
      <div v-loading="Tableloading"
           element-loading-background="rgba(0, 0, 0, 0.7)"
           element-loading-text="数据正在加载，请稍等"
           element-loading-spinner="el-icon-loading">
        <el-table
        :data="tableData"
        :header-cell-style="HeaderCss"
        tooltip-effect="dark"
        stripe
        ref="tableTest"
        style="width: 100%">
        <el-table-column align="center" prop="projectName" label="项目名称"></el-table-column>
        <el-table-column align="center" prop="createTime" label="上传时间"></el-table-column>
        <el-table-column align="center" prop="updateTime" label="更新时间"></el-table-column>
        <el-table-column align="center" prop="userId" label="创建人"></el-table-column>
        <el-table-column align="center" prop="date" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="preView(scope.row)">查看</el-button>
            <el-button type="text" size="small" @click="download(scope.row)">下载</el-button>
            <el-button type="text" size="small" @click="openUpdata(scope.row)">更新</el-button>
            <el-button type="text" size="small" @click="deleteSubmit(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :hide-on-single-page="true"
          :total=totalNum
          :page-size=pageSize
          @current-change="changePage"
          @prev-click="changePage"
          @next-click="changePage"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      id="preViewDialog"
      append-to-body
      title="预览文件"
      :visible.sync="preViewShow"
      width="66%"
      center
    >
      <iframe v-if='pdfUrl' :src=pdfUrl frameborder="0" style="width:100%; height: 66vh"></iframe>
      <img v-if="imgUrl" style="width:100%; height: 66vh" :src=imgUrl alt="">
      <!-- excel查看详情 -->
      <div id="excelView" v-if="excelURL">
        <el-table :data="excelData" style="width: 100%">
          <el-table-column
            v-for="(value, key, index) in excelData[2]"
            :key="index"
            :prop="key"
            :label="key"
          ></el-table-column>
        </el-table>
      </div>

      <div v-if="vHtml" style="width:100%; height: 66vh" id="wordView" v-html="vHtml"/>
    </el-dialog>
    <addDialog :dialogVisible="showAdd" @getData="getProject(1)"></addDialog>
    <updataDialog :updataVisible="showUpdata" :dataInfo="dataInfo" @getData="getProject(1)"></updataDialog>
  </div>
</template>

<script>
  import addDialog from './dialog/uploadFile'
  import updataDialog from './dialog/updataFile'
  import  API_CONFIG from "../../../config/index"
  import * as XLSX from "xlsx";
  import * as mammoth from "mammoth";



    export default {
        name: "DataManagement",
        components:{
            addDialog,
            updataDialog
        },
        data(){
            return{
                select_word:'',
                tableData:[],
                preViewShow:false,
                showAdd:{show:false},
                showUpdata:{show:false},
                Tableloading:false,
                totalNum:null,
                pageSize:10,
                pageNum:1,
                dataInfo:{},
                pdfUrl:'',//pdf地址
                imgUrl:'',//img地址
                excelData: [],
                workbook: {},
                excelURL: "", //文件地址，看你对应怎末获取、赋值
                excelView:'',//excel渲染
                BlobUrl:'',//流文件
                docxUrl:'',//word地址
                vHtml:''
            }
        },
        created() {

        },
        mounted() {
            this.getProject(this.pageNum)
        },
        methods:{
            //搜索
            searchProject(page,name){
                // console.log(page,name,1111)
                this.pageNum=page
                this.Tableloading=true
                let req = {
                    page:page,
                    fileName:name
                }
                this.$axios.post('/api/monitor/fileUpload/searchFile?page='+page+'&fileName='+name).then(res=>{
                    if(res.data.status==200){
                        this.tableData=res.data.datas.values.list
                        this.totalNum=res.data.datas.values.total
                    }else{
                        this.$message.error(res.data.message)
                    }
                    this.Tableloading=false
                }).catch(()=>{
                    this.Tableloading=false
                })
            },
            //fileUpload/getFileData
            getProject(pageNum){
                this.Tableloading=true
                this.$axios.get('/api/monitor/fileUpload/getFileData?page='+pageNum).then(res=>{
                    if(res.data.status==200){
                        this.tableData=res.data.datas.values.list
                        this.totalNum=res.data.datas.values.total
                    }else{
                        this.$message.error(res.data.message)
                    }
                    this.Tableloading=false
                }).catch(()=>{
                    this.Tableloading=false
                })
            },
            //分页查询
            changePage(e){
                this.pageNum=e
                if(this.select_word){
                    this.searchProject(this.pageNum,this.select_word)
                }else {
                    this.getProject(e)
                }
            },
            //预览
            preView(info){

                this.pdfUrl=''
                this.imgUrl=''
                this.excelData=[]
                this.workbook= {}
                this.excelURL= ""
                this.docxUrl=''
                this.vHtml=''
                let api = API_CONFIG.dev.proxyTable['/api'].target+'/monitor/image/'
                let url = info.filePath
                let str = url.split('/')[url.split('/').length-1]
                // console.log(str,111)
                if(str.indexOf('.pdf')!==-1){
                    this.pdfUrl=api+url
                    this.preViewShow=true
                }
                if(str.indexOf('.jpg')!==-1||str.indexOf('.png')!==-1){
                    this.imgUrl=api+url
                    this.preViewShow=true
                }
                if(str.indexOf('.xls')!==-1){
                    // this.getPreviewBlob(info)
                    this.excelURL=api+url
                    this.readWorkbookFromRemoteFile(api+url)
                    // 在线查看excel文件
                }if(str.indexOf('.doc')!==-1) {
                    // let str = '2022\\5\\1\\18\\49\\8\\faec65b3-80d3-47db-b57e-ea8b78cba9a1\\publicFile\\default.pdf'
                    // this.docxUrl='http://110.189.155.28:9000/monitor/image/'+str
                    // // docx.renderAsync(api+url,this.$refs.file) // 渲染到页面预览
                    // window.open("https://view.xdocin.com/view?src="+this.docxUrl);
                    this.readExcelFromRemoteFile(api+url)
                }
            },
            //excle
            readWorkbookFromRemoteFile: function (url) {
                var xhr = new XMLHttpRequest();
                xhr.open("get", url, true);
                xhr.responseType = "arraybuffer";
                let _this = this;
                xhr.onload = function (e) {
                    if (xhr.status === 200) {
                        var data = new Uint8Array(xhr.response);
                        var workbook = XLSX.read(data, { type: "array" });
                        var sheetNames = workbook.SheetNames; // 工作表名称集合
                        _this.workbook = workbook;
                        _this.getTable(sheetNames[0]);
                    }
                };
                xhr.send();
            },
            getTable(sheetName) {
                var worksheet = this.workbook.Sheets[sheetName];
                this.excelData = XLSX.utils.sheet_to_json(worksheet);
                this.preViewShow=true
            },

            //word预览获取文件流
            readExcelFromRemoteFile: function (url) {
                var vm = this;
                var xhr = new XMLHttpRequest();
                xhr.open("get", url, true);
                xhr.responseType = "arraybuffer";
                xhr.onload = function () {
                    if (xhr.status == 200) {
                        mammoth
                            .convertToHtml({ arrayBuffer: new Uint8Array(xhr.response) })
                            .then(function (resultObject) {
                                vm.$nextTick(() => {
                                    vm.vHtml = resultObject.value;
                                    vm.preViewShow=true
                                    // console.log(vm.vHtml,41)
                                });
                            });
                    }
                };
                xhr.send();
                },

            getPreviewBlob(info){
                this.$axios.get('/api/monitor/fileUpload/downLoadFile?filePath='+info.filePath,{responseType: 'blob'}).then(res=>{
                    this.BlobUrl=res.data
                })
            },
            //下载fileUpload/downLoadFile
            download(info){
                this.$axios.get('/api/monitor/fileUpload/downLoadFile?filePath='+info.filePath,{responseType: 'blob'}).then(res=>{
                    if (res.data.type == 'text/html') {
                        this.$message({
                            type: 'error',
                            message: '文件不存在或已被删除'
                        })
                        return
                    }
                    // TODO 这里实际上拿不到返回的状态码
                    if (res.status == 201) {
                        this.$message({
                            type: 'error',
                            message: '文件为空'
                        })
                        return
                    }
                    // 处理返回的文件流
                    let info = res.config.url
                    let type = info.split('/')[info.split('/').length-1].split('.')[1]
                    const content = res.data;
                    const blob = new Blob([content], {type: "application/"+type});
                    let fileName = decodeURI(res.headers['content-disposition'].match(/=(.*)$/)[1])
                    if ("download" in document.createElement("a")) {
                        // 非IE下载
                        const downloadElement = document.createElement("a");
                        downloadElement.download = fileName;
                        downloadElement.href = window.URL.createObjectURL(blob); // 创建下载的链接
                        document.body.appendChild(downloadElement);
                        downloadElement.click();  // 点击下载
                        window.URL.revokeObjectURL(downloadElement.href); // 释放blob对象
                        document.body.removeChild(downloadElement); //下载完成移除元素
                    } else {
                        navigator.msSaveBlob(blob, fileName);
                    }
                })
            },
            //更新
            openUpdata(info){
                this.showUpdata.show=true
                this.dataInfo=info
            },
            //删除 fileUpload/deleteFileData
            deleteSubmit(info){
                // let req  = {id:info.id}
                this.$axios.delete('/api/monitor/fileUpload/deleteFileData?id='+info.id).then(res=>{
                    if(res.data.status==200){
                        this.$message.success('删除成功')
                        this.getProject(this.pageNum)
                    }else{
                        this.$message.error(res.data.message)
                    }
                })
            },
            //预览Excel
            setStyle4ExcelHtml() {
                const excelViewDOM = document.getElementById("excelView");
                if (excelViewDOM) {
                    const excelViewTDNodes = excelViewDOM.getElementsByTagName("td"); // 获取的是HTMLConnection
                    if (excelViewTDNodes) {
                        const excelViewTDArr = Array.prototype.slice.call(excelViewTDNodes);
                        for (const i in excelViewTDArr) {
                            const id = excelViewTDArr[i].id; // 默认生成的id格式为sjs-A1、sjs-A2......
                            if (id) {
                                const idNum = id.replace(/[^0-9]/gi, ""); // 提取id中的数字，即行号
                                if (idNum && (idNum === "1" || idNum === 1)) {
                                    // 第一行标题行
                                    excelViewTDArr[i].classList.add("class4Title");
                                }
                                if (idNum && (idNum === "2" || idNum === 2)) {
                                    // 第二行表头行
                                    excelViewTDArr[i].classList.add("class4TableTh");
                                }
                            }
                        }
                    }
                }
            },
            HeaderCss(){
                return 'background:#1653BD;color:#ffffff;font-size:14px'
            },
            search(){}
        }
    }
</script>

<style>
  #mainTabel  .el-table__row {
    color: #ffffff;
  }
  #mainTabel .el-table--striped .el-table__body tr.el-table__row--striped td{
    background-color: rgba(2,21,53,1);
  }
  #mainTabel  .el-table__body tr.el-table__row td{
    background-color: rgba(11,58,104,1) ;
  }

  /*行boder*/
  #mainTabel .el-table {
    border-right: unset;
    border-bottom:unset;
  }
  #mainTabel .el-table--border td, #mainTabel .el-table--border th{
    border-right:  1px solid #333333;
  }
  /*#table .el-table--border td,#table .el-table--border th{*/
  /*  border-left:  1px solid #333333;*/
  /*}*/
  #mainTabel .el-table td, #mainTabel .el-table th{
    border-bottom: 1px solid #333333;
  }

  #dataContent .headerInput .el-input__inner {
    background: #091B3D;
    border: 2px solid #2A4E97;
    border-radius: 6px;
    font-size: 14px;
    color: #ffffff;
  }

</style>
<style scoped>
  @import url('../../assets/css/content.css');
  #wordView{
    overflow:auto;
  }
  #excelView{
    overflow:auto;
  }


</style>



// WEBPACK FOOTER //
// src/components/project/DataManagement.vue